import './stepper.scss';

export const Stepper = ({ steps, current }) => (
  <div className="stepper">
    {steps.map((label, i) => (
      <div key={i} className="stepper__item">
        <div className={`stepper__dot${i < current ? ' done' : i === current ? ' active' : ''}`}>
          {i < current ? '✓' : i + 1}
        </div>
        {i < steps.length - 1 && (
          <div className={`stepper__line${i < current ? ' done' : ''}`} />
        )}
      </div>
    ))}
  </div>
);
